module.exports = __webpack_public_path__ + "img/oticas_wanny.a5579104.svg";